document.addEventListener("DOMContentLoaded", () => {
  const stickyATC = document.querySelector("[data-sticky-atc]");
  const mainProductInfo = document.querySelector("product-info");
  const sectionId = mainProductInfo?.getAttribute("data-section");

  const stickyProductForm = document.querySelector(`#product-form-sticky-${sectionId}`);

  const mainProductPrice = document.querySelector(`#price-${sectionId}`);
  const stickyProductPrice = document.querySelector(`#price-sticky-${sectionId}`);

  const stickyVariantDisplay = document.querySelector("[data-sticky-atc-variant]");

  const qtyInput = document.querySelector(".quantity-input");
  const minusBtn = document.querySelector(".qty-minus");
  const plusBtn = document.querySelector(".qty-plus");

  if (!stickyATC || !mainProductInfo || !stickyProductForm || !sectionId) return;

  /* -------------------------------------------------------
    Sticky ATC visibility
  ------------------------------------------------------- */
  new IntersectionObserver(([entry]) => {
    const isVisible = entry.isIntersecting;

    stickyATC.classList.toggle("is-shown", !isVisible);
    stickyATC.hidden = isVisible;

    document.body.style.setProperty("--sticky-atc-height", `${stickyATC.offsetHeight}px`);
  }, { threshold: 0.1 }).observe(mainProductInfo);

  /* -------------------------------------------------------
    Quantity Button Logic
  ------------------------------------------------------- */
  if (qtyInput && minusBtn && plusBtn) {
    minusBtn.addEventListener("click", () => {
      const current = Number(qtyInput.value);
      const min = Number(qtyInput.dataset.min || 1);

      if (current > min) {
        qtyInput.value = current - 1;
        qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });

    plusBtn.addEventListener("click", () => {
      const current = Number(qtyInput.value);
      const step = Number(qtyInput.step || 1);
      const max = qtyInput.dataset.max ? Number(qtyInput.dataset.max) : null;

      if (!max || current < max) {
        qtyInput.value = current + step;
        qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }

  /* -------------------------------------------------------
    Scroll to product info
  ------------------------------------------------------- */
  stickyVariantDisplay?.addEventListener("click", () => {
    mainProductInfo?.scrollIntoView({ behavior: "smooth", block: "start" });
  });

  /* -------------------------------------------------------
    Variant syncing references
  ------------------------------------------------------- */
  const stickyVariantInput = stickyProductForm.querySelector('input[name="id"]');
  const mainSubmitButton = document.querySelector(`#ProductSubmitButton-${sectionId}`);
  const stickySubmitButton = stickyProductForm.querySelector(".product-form__submit");

  const mainQuantityInput = document.querySelector('[data-main-product="quantity"]');
  const stickyQuantityInput = document.querySelector('[data-sticky-atc="quantity-input"]');

  /* -------------------------------------------------------
    Quantity Rules Syncing
  ------------------------------------------------------- */
  const updateQuantityRules = (variant) => {
    if (!stickyQuantityInput || !variant || !mainQuantityInput) return;

    // ---- COPY MIN ----
    const min = mainQuantityInput.getAttribute("min") || 1;
    stickyQuantityInput.setAttribute("min", min);
    stickyQuantityInput.dataset.min = min;

    // ---- COPY MAX ----
    const max = mainQuantityInput.getAttribute("max");

    if (max !== null && max !== "" && max !== undefined) {
      stickyQuantityInput.setAttribute("max", max);
      stickyQuantityInput.dataset.max = max;
    } else {
      stickyQuantityInput.removeAttribute("max");
      stickyQuantityInput.dataset.max = "";
    }

    // ---- COPY STEP ----
    const step = mainQuantityInput.getAttribute("step") || 1;
    stickyQuantityInput.setAttribute("step", step);

    // ---- Reset both inputs to MIN ----
    stickyQuantityInput.value = min;
    mainQuantityInput.value = min;
  };

  /* -------------------------------------------------------
    Update variant text
  ------------------------------------------------------- */
  const updateVariantDisplay = () => {
    try {
      const vari = JSON.parse(
        document.querySelector('script[data-selected-variant]')?.textContent || "{}"
      );

      if (vari?.title && stickyVariantDisplay) {
        stickyVariantDisplay.textContent = vari.title;
      }
    } catch (err) {
      console.warn("Variant JSON parse failed:", err);
    }
  };

  /* -------------------------------------------------------
    Master Sync Function
  ------------------------------------------------------- */
  const syncStickyATC = (variantId) => {
    if (stickyVariantInput) stickyVariantInput.value = variantId;

    const variantData = JSON.parse(
      document.querySelector('script[data-selected-variant]')?.textContent || "{}"
    );

    updateVariantDisplay();
    updateQuantityRules(variantData);

    // Price sync
    if (mainProductPrice && stickyProductPrice) {
      stickyProductPrice.innerHTML = mainProductPrice.innerHTML;
    }

    // Button sync
    if (mainSubmitButton && stickySubmitButton) {
      stickySubmitButton.disabled = mainSubmitButton.disabled;

      const mainText = mainSubmitButton.querySelector("span")?.textContent;
      const stickyText = stickySubmitButton.querySelector("span");

      if (mainText && stickyText) stickyText.textContent = mainText;
    }
  };

  /* -------------------------------------------------------
    Sync quantity between forms
  ------------------------------------------------------- */
  if (mainQuantityInput && stickyQuantityInput) {
    stickyQuantityInput.value = mainQuantityInput.value;

    mainQuantityInput.addEventListener("change", () => {
      stickyQuantityInput.value = mainQuantityInput.value;
    });

    stickyQuantityInput.addEventListener("change", () => {
      mainQuantityInput.value = stickyQuantityInput.value;
    });
  }

  /* -------------------------------------------------------
    Variant change listeners
  ------------------------------------------------------- */
  const handleVariantChange = (e) => {
    if (e.target.closest("[data-sticky-atc]")) return;

    const variantId = e.target.value;
    setTimeout(() => syncStickyATC(variantId), 50);
  };

  document.querySelectorAll('input[name="id"]').forEach((input) => {
    input.addEventListener("change", handleVariantChange);
  });

  /* -------------------------------------------------------
    INITIAL LOAD SYNC
  ------------------------------------------------------- */
  const initialVariant = document.querySelector('input[name="id"]')?.value;
  if (initialVariant) syncStickyATC(initialVariant);
});
